export default "__VITE_ASSET__D_IyGpo6__"